var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullActiveFitBot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4702 1.87754H9.95095V0.525711C9.95095 0.386283 9.89556 0.252567 9.79697 0.153977C9.69838 0.0553872 9.56466 0 9.42524 0H8.59912C8.45969 0 8.32598 0.0553872 8.22739 0.153977C8.1288 0.252567 8.07341 0.386283 8.07341 0.525711V1.87754H3.55418C2.6117 1.87803 1.70797 2.25265 1.04154 2.91908C0.375114 3.58551 0.000497479 4.48924 0 5.43172V7.54958C0 9.8795 0.92556 12.114 2.57307 13.7615C4.22057 15.409 6.45507 16.3346 8.785 16.3346H9.42524C9.56466 16.3346 9.69838 16.2792 9.79697 16.1806C9.89556 16.082 9.95095 15.9483 9.95095 15.8089V14.9827C9.95095 14.8433 9.89556 14.7096 9.79697 14.611C9.69838 14.5124 9.56466 14.457 9.42524 14.457H8.785C6.95303 14.457 5.19609 13.7293 3.90069 12.4339C2.60529 11.1385 1.87754 9.38155 1.87754 7.54958V5.43172C1.87754 4.98704 2.05418 4.56058 2.36861 4.24615C2.68305 3.93172 3.10951 3.75507 3.55418 3.75507H14.4702C14.9149 3.75507 15.3413 3.93172 15.6557 4.24615C15.9702 4.56058 16.1468 4.98704 16.1468 5.43172V7.6979C16.1456 8.21302 16.0826 8.72613 15.9591 9.22622C15.9263 9.35507 15.9438 9.49155 16.0079 9.608C16.0721 9.72445 16.1781 9.81214 16.3045 9.85332L17.0931 10.1105C17.1612 10.1331 17.2333 10.1415 17.3047 10.1351C17.3762 10.1287 17.4456 10.1077 17.5087 10.0734C17.5717 10.0391 17.627 9.99214 17.6711 9.93555C17.7153 9.87896 17.7473 9.81391 17.7653 9.74442C17.936 9.0756 18.023 8.38817 18.0244 7.6979V5.43172C18.0239 4.48924 17.6492 3.58551 16.9828 2.91908C16.3164 2.25265 15.4127 1.87803 14.4702 1.87754Z",
    fill: "url(#paint0_linear_6573_1862)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00789 9.76334C6.83744 9.76334 7.50992 9.09086 7.50992 8.26131C7.50992 7.43176 6.83744 6.75928 6.00789 6.75928C5.17834 6.75928 4.50586 7.43176 4.50586 8.26131C4.50586 9.09086 5.17834 9.76334 6.00789 9.76334Z",
    fill: "url(#paint1_linear_6573_1862)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0157 9.76334C12.8453 9.76334 13.5177 9.09086 13.5177 8.26131C13.5177 7.43176 12.8453 6.75928 12.0157 6.75928C11.1862 6.75928 10.5137 7.43176 10.5137 8.26131C10.5137 9.09086 11.1862 9.76334 12.0157 9.76334Z",
    fill: "url(#paint2_linear_6573_1862)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9732 15.1705L19.6742 15.8407C19.7092 15.8546 19.7393 15.8786 19.7605 15.9098C19.7816 15.9409 19.793 15.9777 19.793 16.0154C19.793 16.053 19.7816 16.0898 19.7605 16.1209C19.7393 16.1521 19.7092 16.1761 19.6742 16.19L17.9732 16.8602C17.672 16.9793 17.3985 17.1589 17.1696 17.3878C16.9406 17.6168 16.761 17.8903 16.642 18.1914L15.9717 19.8812C15.9579 19.9162 15.9338 19.9463 15.9027 19.9674C15.8715 19.9886 15.8347 19.9999 15.7971 19.9999C15.7594 19.9999 15.7227 19.9886 15.6915 19.9674C15.6604 19.9463 15.6363 19.9162 15.6225 19.8812L14.9522 18.1914C14.8334 17.8901 14.654 17.6165 14.425 17.3875C14.196 17.1585 13.9223 16.979 13.621 16.8602L11.9312 16.19C11.8962 16.1761 11.8662 16.1521 11.845 16.1209C11.8238 16.0898 11.8125 16.053 11.8125 16.0154C11.8125 15.9777 11.8238 15.9409 11.845 15.9098C11.8662 15.8786 11.8962 15.8546 11.9312 15.8407L13.621 15.1705C13.9223 15.0517 14.196 14.8722 14.425 14.6432C14.654 14.4142 14.8334 14.1406 14.9522 13.8393L15.6225 12.1495C15.6363 12.1145 15.6604 12.0844 15.6915 12.0633C15.7227 12.0421 15.7594 12.0308 15.7971 12.0308C15.8347 12.0308 15.8715 12.0421 15.9027 12.0633C15.9338 12.0844 15.9579 12.1145 15.9717 12.1495L16.642 13.8393C16.761 14.1404 16.9406 14.4139 17.1696 14.6429C17.3985 14.8718 17.672 15.0514 17.9732 15.1705Z",
    fill: "url(#paint3_linear_6573_1862)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6573_1862",
    x1: 4.47243,
    y1: 0.980388,
    x2: 12.1275,
    y2: 15.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6573_1862",
    x1: 5.25127,
    y1: 6.93958,
    x2: 6.73532,
    y2: 9.51004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6573_1862",
    x1: 11.2591,
    y1: 6.93958,
    x2: 12.7431,
    y2: 9.51004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6573_1862",
    x1: 13.7927,
    y1: 12.5091,
    x2: 17.7268,
    y2: 19.3328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullActiveFitBot);
export default __webpack_public_path__ + "static/media/FullActiveFitBot.5200297c3583746aea0d50e5181db273.svg";
export { ForwardRef as ReactComponent };